module.exports = __webpack_public_path__ + "img/zh-4.ea0db130.jpg";